<div
  class="phone-input"
  [class.phone-input--invalid]="hasErrors"
  [class.phone-input--disabled]="disabled"
  [class.phone-input--manual-mode]="mode === 'manual-calling-code'">
  <div class="phone-input__controls-wrapper">
    <div class="phone-input__controls" [class.phone-input__controls--loading]="loading">
      @if (mode === 'country-select' && countryOptions.length) {
        <nz-select
          #countrySelectComponent
          class="phone-input__country"
          [ngModel]="selectedCountryId"
          (ngModelChange)="onCountryChange($event)"
          (nzOpenChange)="onCountryOpenChange($event)"
          (nzOnSearch)="onCountrySearch($event)"
          (keydown.tab)="onCountrySelectKeyDown($event)"
          (keydown.enter)="onCountrySelectKeyDown($event)"
          [ngModelOptions]="{ standalone: true }"
          [nzDisabled]="disabled || loading"
          [nzShowSearch]="true"
          [nzShowArrow]="false"
          [nzSelectOnTab]="true"
          [nzCustomTemplate]="selectedCountryTemplate"
          nzDropdownClassName="phone-input__dropdown"
          [nzDropdownMatchSelectWidth]="false"
          [nzPlaceHolder]="selectPlaceholder"
          [nzAllowClear]="false">
          @for (option of countryOptions; track option) {
            <nz-option nzCustomContent [nzValue]="option.id" [nzLabel]="option.searchLabel">
              <div class="phone-input__country-option">
                <span class="phone-input__country-option-name phone-input__country-option-name--desktop">
                  {{ option.countryLabel }}
                </span>
                <span class="phone-input__country-option-name phone-input__country-option-name--mobile">
                  {{ option.alpha2 }}
                </span>
                <span class="phone-input__country-option-code">{{ option.formattedCallingCode }}</span>
              </div>
            </nz-option>
          }
        </nz-select>
        <ng-template #selectedCountryTemplate>
          @if (selectedCountryOption; as option) {
            <div class="phone-input__country-trigger">
              <span class="phone-input__country-trigger-code">{{ option.formattedCallingCode }}</span>
            </div>
          }
        </ng-template>
      } @else if (mode === 'manual-calling-code') {
        <div class="phone-input__country phone-input__country--manual">
          <span class="phone-input__manual-calling-code-prefix">+</span>
          <input
            #manualCallingCodeInput
            class="phone-input__manual-calling-code-input ant-input"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="tel-country-code"
            [disabled]="disabled || loading"
            [ngModel]="manualCallingCode"
            (ngModelChange)="onManualCallingCodeChange($event)"
            (keydown)="onManualCallingCodeKeyDown($event)"
            (paste)="onManualCallingCodePaste($event)"
            [ngModelOptions]="{ standalone: true }"
            maxlength="3"
            (blur)="markAsTouched()" />
        </div>
      }

      <input
        #phoneNumberInput
        nz-input
        class="phone-input__number"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="tel-national"
        [id]="inputId"
        [disabled]="disabled || loading"
        [ngModel]="localPhoneNumber"
        (ngModelChange)="onLocalPhoneNumberChange($event)"
        (keydown)="onPhoneNumberKeyDown($event)"
        (paste)="onPhoneNumberPaste($event)"
        [ngModelOptions]="{ standalone: true }"
        [placeholder]="numberPlaceholder | translate"
        (blur)="markAsTouched()" />
    </div>

    @if (loading) {
      <div class="phone-input__loading-overlay" aria-hidden="true">
        <mat-spinner [diameter]="18"></mat-spinner>
      </div>
    }
  </div>

  @if (hasErrors && mode !== 'manual-calling-code') {
    <div class="phone-input__error">
      {{ ngControl?.control?.errors | errorsFormatingAndTranslate }}
    </div>
  }
</div>
